var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlCableTvOutlined = function SvgHtlCableTvOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 14H5.5a.5.5 0 0 1 0-1h2v-1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.5v1h2a.5.5 0 0 1 0 1H8Zm-5-3h10V3H3v8Zm6.749-2a.5.5 0 0 1-.279-.086l-.028-.021a.5.5 0 0 1-.163-.232l-1-3a.5.5 0 1 1 .949-.316l.526 1.577.527-1.577a.5.5 0 0 1 .948.316l-.995 2.983a.525.525 0 0 1-.056.122l-.006.01-.005.007a.077.077 0 0 1-.006.009v.007a.02.02 0 0 0-.006.006l-.008.01-.005.006-.005.006-.01.01-.004.005-.007.007-.006.005-.01.009-.012.011-.011.009-.013.01-.01.006h-.004l-.01.007-.01.005a.506.506 0 0 1-.249.067L9.749 9Zm-4-.5V6h-.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1h-.5v2.5a.5.5 0 0 1-1 0Z"
  })));
};
export default SvgHtlCableTvOutlined;